export default __webpack_public_path__ + "static/media/heart.07db2fdf.svg";